// React
import React, { useState, useRef, useEffect } from "react";
// React
// CSS
import styles from "./PurchaseModal.module.css";
import "./swalConfig.css";
// CSS
// Services
import { getUserProfile_Service } from "../../../../../Services/Profile/get/getUserProfile_Service";
import { buyKonkurBookletPdfService } from "../../../../../Services/Buy/post/buyBookletPdfService";
import { getKonkurBookletPdfsService } from "../../../../../Services/KonkurBooklets/get/getKonkurPdfsService";
// Services
// Modules
import Swal from "sweetalert2";
// Modules
// Images
import { dialog_shop_header } from "../../../../../Images/images";
// Images
// Utils
import HelperHeader from "../../../../../Utils/HelperHeader/HelperHeader";
import Spinner from "../../../../../Utils/Spinner/Spinner";
// Utils
// Models
import { I_KonkurBookletPdf } from "../../../../../Models/interfaces";
// import { getTeacherTeachItemsService } from "../../../../../Services/Teachers/get/getTeacherTeachItemsService";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
// Models

type PurchaseModalProps = {
  setIsModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
  userToken: string;
  pdfItemId: string | number;
  isPaid: boolean;
  productName: string;
  productPrice: string | number;
  categoryId: string | number;
  setCategoryPdfsMap: React.Dispatch<React.SetStateAction<Record<number, I_KonkurBookletPdf[]>>>;
};

const PurchaseModal: React.FunctionComponent<PurchaseModalProps> = ({
  setIsModalOpen,
  pdfItemId,
  userToken,
  isPaid,
  productName,
  productPrice,
  categoryId,
  setCategoryPdfsMap,
}) => {
  const outerRef = useRef<HTMLDivElement>(null);
  const contentRef = useRef<HTMLDivElement>(null);

  const [isPending, setIsPending] = useState<boolean>(false);
  const [isWalletPending, setIsWalletPending] = useState<boolean>(true);
  const [wallet, setWallet] = useState<number>(0);
  const [giftWallet, setGiftWallet] = useState<number>(0);
  const [payWithWallet, setPayWithWallet] = useState<number>(0);
  const [payWithGiftWallet, setPayWithGiftWallet] = useState<number>(0);
  const [finalPrice, setFinalPrice] = useState<number>(Number(productPrice));

  const closeModal = () => {
    if (!outerRef.current) return;
    if (!contentRef.current) return;
    outerRef.current.style.opacity = "0";
    contentRef.current.style.top = "120vh";
    setTimeout(() => {
      setIsModalOpen(false);
    }, 500);
  };

  useEffect(() => {
    let final_price = Number(productPrice);
    if (payWithGiftWallet) {
      if (final_price > giftWallet) {
        final_price -= giftWallet;
      } else {
        final_price = 0;
      }
    }
    if (payWithWallet) {
      if (final_price > wallet) {
        final_price -= wallet;
      } else {
        final_price = 0;
      }
    }
    setFinalPrice(final_price);
  }, [payWithWallet, payWithGiftWallet, wallet, giftWallet, productPrice]);

  useEffect(() => {
    setTimeout(() => {
      if (!outerRef.current) return;
      if (!contentRef.current) return;
      contentRef.current.style.top = "0";
      outerRef.current.style.opacity = "1";
    }, 30);
  }, []);

  useEffect(() => {
    if (isPaid) {
      setIsWalletPending(false);
    } else {
      getUserProfile_Service(userToken)
        .then(({ data: { data } }) => {
          setWallet(data.wallet);
          setGiftWallet(data.gift_wallet);
          // console.log(data);
          setIsWalletPending(false);
        })
        .catch((err: any) => {
          setIsWalletPending(false);
          toast(
            err.response.data.message ? err.response.data.message : err.message,
          );
        });
    }
  }, [userToken, isPaid]);
  return (
    <div
      className={`${
        styles.lessonCardModalContainer
      } fixed w-screen h-screen top-0 ${
        window.innerWidth > 600 ? "left-auto" : "left-0"
      }  flex items-center justify-center [direction:rtl]`}
      style={{
        marginLeft: window.innerWidth > 600 ? "-52px" : "",
      }}
    >
      <div
        className={`${styles.outer} absolute z-10 w-screen h-screen `}
        ref={outerRef}
        onClick={closeModal}
      ></div>
      <div
        className={`${styles.inner} flex flex-col items-start w-11/12 p-4 bg-white relative z-20 rounded-2xl`}
        ref={contentRef}
      >
        <HelperHeader
          absoluteText="خریـــــد محـــــصول"
          className="mt-2"
          isBgWhite={true}
        />
        <img src={dialog_shop_header} alt="" />
        <p className="mt-2 text-sm">{productName}</p>
        <p className="mt-4 flex flex-row items-center text-xs">
          <span>مبلغ قابل پرداخت : </span>
          <span>{productPrice} تومان</span>
        </p>
        {!isPaid ? (
          <>
            <p className="mt-6" style={{ display: "flex", direction: "rtl" }}>
              <div style={{ display: "flex", alignItems: "center" }}>
                <input
                  disabled={!giftWallet}
                  className="ml-2"
                  onChange={() => {
                    setPayWithGiftWallet((state) => (state ? 0 : 1));
                  }}
                  type="checkbox"
                />
                <label>کیف پول هدیه : </label>
              </div>
              <div>
                {isWalletPending ? (
                  <SkeletonTheme
                    baseColor="rgba(126, 58, 229 , 0.1)"
                    highlightColor="rgba(126, 0, 229, 0.6)"
                  >
                    <Skeleton
                      count={1}
                      width={"40px"}
                      height={"20px"}
                      style={{ marginRight: "10px" }}
                    />
                  </SkeletonTheme>
                ) : (
                  <span className="mr-1">{giftWallet}</span>
                )}
              </div>
            </p>
            <p className="mt-1" style={{ display: "flex", direction: "rtl" }}>
              <div style={{ display: "flex", alignItems: "center" }}>
                <input
                  disabled={!wallet}
                  className="ml-2"
                  onChange={() => {
                    setPayWithWallet((state) => (state ? 0 : 1));
                  }}
                  type="checkbox"
                />
                <label>کیف پول اصلی : </label>
              </div>
              <div>
                {isWalletPending ? (
                  <SkeletonTheme
                    baseColor="rgba(126, 58, 229 , 0.1)"
                    highlightColor="rgba(126, 0, 229, 0.6)"
                  >
                    <Skeleton
                      count={1}
                      width={"40px"}
                      height={"20px"}
                      style={{ marginRight: "10px" }}
                    />
                  </SkeletonTheme>
                ) : (
                  <span className="mr-1">{wallet}</span>
                )}
              </div>
            </p>
          </>
        ) : (
          ""
        )}
        <button
          onClick={() => {
            if (isPending) return;
            setIsPending(true);
            if (isPaid === true) {
              buyKonkurBookletPdfService(
                userToken,
                pdfItemId,
                payWithWallet,
                payWithGiftWallet,
              )
                .then(({ data }) => {
                  console.log(data);
                  console.log("x");
                  Swal.fire({ icon: "info", title: data.data });
                  setIsPending(false);
                })
                .catch((err) => {
                  setIsPending(false);
                  console.log(err);
                  toast(
                    err.response.data.message
                      ? err.response.data.message
                      : err.message,
                  );
                });
              return;
            }
            if (isPaid === false) {
              buyKonkurBookletPdfService(
                userToken,
                pdfItemId,
                payWithWallet,
                payWithGiftWallet,
              )
                .then(({ data }) => {
                  console.log(data);
                  //
                  //
                  //
                  //
                  if (data.url) {
                    window.location.href = data.url;
                    return;
                  }
                  if (data.data !== "موجودی کیف پول کافی نمی باشد!") {
                    Swal.fire({
                      icon: "success",
                      title: "خرید موفق",
                      text: data.data,
                    }).then(() => {
                      (() => {
                        getKonkurBookletPdfsService(userToken, {
                          categoryId: categoryId || "",
                        })
                          .then(({ data: { data } }) => {
                            setCategoryPdfsMap((prev) => ({ ...prev, [categoryId]: data }));
                            closeModal();
                          })
                          .catch((err) => {
                            console.log(err);
                            Swal.fire({
                              icon: "error",
                              title: err.response.data.message
                                ? err.response.data.message
                                : err.message,
                            });
                          });
                      })();
                    });
                    return;
                  }

                  toast(data.data);
                  //
                  //
                  //
                  //
                  (() => {
                    getKonkurBookletPdfsService(userToken, {
                      categoryId: categoryId || "",
                    })
                      .then(({ data: { data } }) => {
                        console.log(data);
                        setCategoryPdfsMap((prev) => ({ ...prev, [categoryId]: data }));
                        closeModal();
                      })
                      .catch((err) => {
                        console.log(err);
                        Swal.fire({
                          icon: "error",
                          title: err.response.data.message
                            ? err.response.data.message
                            : err.message,
                        });
                      });
                  })();
                  //
                  //
                  //
                  //
                  setIsPending(false);
                })
                .catch((err) => {
                  console.log(err);
                  Swal.fire({
                    icon: "error",
                    title: err.response.data.message
                      ? err.response.data.message
                      : err.message,
                  });
                  setIsPending(false);
                });
              return;
            }
          }}
          className={`${styles.buyBtn} w-full text-center mt-6 text-sm text-white py-2 rounded-xl`}
        >
          {isPending || isWalletPending ? (
            <span className="flex items-center justify-center">
              <Spinner />
            </span>
          ) : (
            <>
              {productPrice === 0 ? (
                <>استفاده ی رایگان</>
              ) : (
                <>
                  <span>پرداخت</span>
                  <span
                    className={
                      "mr-1 " +
                      (payWithWallet || payWithGiftWallet ? "line-through" : "")
                    }
                  >
                    {productPrice} تومان
                  </span>
                  {payWithWallet || payWithGiftWallet ? (
                    <span className="mr-2">{finalPrice} تومان</span>
                  ) : (
                    ""
                  )}
                </>
              )}
            </>
          )}
        </button>
      </div>
    </div>
  );
};

export default PurchaseModal;
